<template>
  <div>
    <el-form-item label="分割文案">
      <el-input v-model="activeData.content" placeholder="请输入分割线内文案" />
    </el-form-item>
    <el-form-item label="分割样式">
      <el-select v-model="activeData.borderStyle" placeholder="请选择">
        <el-option v-for="item in borderStyleOptions" :key="item.value" :label="item.label" :value="item.value">
          <div style="width: 100%; display: flex; justify-content: space-around; align-items: center">
            <span>{{ item.label }}</span>
            <div
              :style="{
                flex: '1',
                marginLeft: '6px',
                borderTop: `1px ${item.value} #999999`
              }"
            ></div>
          </div>
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigItemDivider',
  props: ['activeData'],
  data() {
    return {
      borderStyleOptions: [
        {
          value: 'solid',
          label: '实线'
        },
        {
          value: 'dashed',
          label: '虚线'
        },
        {
          value: 'dotted',
          label: '点线'
        }
      ]
    }
  }
}
</script>

<style scoped></style>
